import { render, staticRenderFns } from "./PortalBuscaForm.vue?vue&type=template&id=4f5dddbb&scoped=true&"
import script from "./PortalBuscaForm.vue?vue&type=script&lang=js&"
export * from "./PortalBuscaForm.vue?vue&type=script&lang=js&"
import style0 from "./PortalBuscaForm.vue?vue&type=style&index=0&id=4f5dddbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5dddbb",
  null
  
)

export default component.exports